import camelcaseKeys from 'camelcase-keys';
import restService from '../../../../utils/networkService';
export type SuccessCallback = (response?: any) => void;
export type ErrorCallback = (response?: any) => void;

export const transformCamelCase = <T extends Record<string, any>>(response: T): T => {
    return camelcaseKeys(response, { deep: true }) as T;
};

export const getData = (
    url: string,
    callback: (response: any) => void,
    onError: (response: any) => void,
    options?: { isTransformCamelCase?: boolean }
) => {
    restService
        .request({
            url,
            method: 'GET',
            withCredentials: true,
        })
        .then(
            (response: any) => {
                const data = options?.isTransformCamelCase ? transformCamelCase(response.data) : response.data;
                callback?.(data);
            },
            e => {
                onError?.(e?.response?.data);
            }
        );
};

export const postData = (
    url: string,
    data: any,
    callback: (response: any) => void,
    onError: (response: any) => void
) => {
    restService
        .request({
            url,
            method: 'POST',
            data,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
        })
        .then(
            (response: any) => {
                callback?.(response.data);
            },
            (response: any) => {
                onError?.(response.data);
            }
        );
};

export const putData = (url: string, callback: (response: any) => void, onError: (response: any) => void) => {
    restService
        .request({
            url,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
        })
        .then(
            (response: any) => {
                callback?.(response.data);
            },
            (response: any) => {
                onError?.(response.data);
            }
        );
};

export const addAuthorizationHeader = restService.addAuthorizationHeader;
export const deleteAuthorizationHeader = restService.deleteAuthorizationHeader;
export const getAuthorizationHeader = restService.getAuthorizationHeader;
export { restService };
